import {
    Texture,
    NineSlicePlane
} from 'pixi.js';
import { Focusable } from '../../../ui';
import { LoadContext } from '../../../utils';

const FRAME_WIDTH = 25;
const FOCUS_FRAME_WIDTH = 6;

export class RoundedRect extends NineSlicePlane implements Focusable
{
    public static preload()
    {
        LoadContext.current.add('SharedUI', './assets/shared/SharedUI{size}.json');
    }

    protected focusBox: NineSlicePlane = null;
    constructor(tex: Texture, width: number, height: number, focusable = false)
    {
        super(tex, FRAME_WIDTH, FRAME_WIDTH, FRAME_WIDTH, FRAME_WIDTH);
        this.width = width;
        this.height = height;

        if (focusable)
        {
            this.focusBox = new NineSlicePlane(LoadContext.current.getSpritesheet('SharedUI').textures['highlight_frame'], FOCUS_FRAME_WIDTH, FOCUS_FRAME_WIDTH, FOCUS_FRAME_WIDTH, FOCUS_FRAME_WIDTH);
            // make box just a tad bigger than whatever the size is
            this.focusBox.width = width + 2;
            this.focusBox.height = height + 2;
            this.focusBox.position.set(-2, -2);
            this.addChild(this.focusBox);
            this.focusBox.visible = false;
        }
    }

    public activate()
    {
        // don't do anything here
    }

    public get focus() { return this.focusBox?.visible; }
    public set focus(focused) {
        this.focusBox.visible = focused;
        if (focused)
        {
            this.emit('pointerover');
            this.emit('focused');
        }
        else
        {
            this.emit('pointerout');
            this.emit('unfocused');
        }
    }

    public get focusVisible() { return this.focusBox.visible; }
    public set focusVisible(visible) {
        this.focusBox.visible = visible;
    }

    public destroy()
    {
        super.destroy({children: true});
    }
}